import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Stack,
  CardContent,
  Collapse,
  Box,
  Container,
  Typography,
  CircularProgress,
  Grid,
  Pagination,
  TextField,
  Autocomplete,
  Modal,
  MenuItem,
  Button
} from '@mui/material';

import { useAxios } from '../context/AxiosHookContext';
import { cargos } from '../utils/lists';
import { useNotification } from '../context/NotificationContext';

import Iconify from '../components/iconify';
import PersonalitiesModalForm from '../components/forms/personalities/personalitiesModalForm/PersonalitiesModalForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: "90%", md: "70%", lg: "50%" },
  bgcolor: 'background.paper',
  outline: "none",
  border: '0px',
  boxShadow: 24,
  p: 2,
  borderRadius: 4
};


const FuncionarioCard = ({ funcionario = {}, onClose = () => true }) => {

  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [selectedValuesToEdit, selectValuesToEdit] = useState(funcionario);


  return (
    <Card sx={{
      border: "1px solid #dfd2d2", borderRadius: 2, margin: 2,
      borderTop: `3px solid ${funcionario?.estado ? '#3b5a1e' : '#6da33c'}`,
      borderRight: `3px solid ${funcionario?.estado ? '#3b5a1e' : '#6da33c'}`
    }}>
      <CardContent onDoubleClick={() => {
        setOpenModalEdit(true);
        selectValuesToEdit(funcionario);
      }}>
        <Grid container spacing={2}>

          <Grid item xs={2}>
            <img src={funcionario.foto || "https://observicios.gob.do/back/api/funcionarios/6391/foto"} alt="foto-funcionario" style={{
              objectFit: "contain",
              height: 160,
              width: 160,
              minHeight: 160,
              minWidth: 160,
              borderRadius: "100%",
              border: `solid 4px ${funcionario?.historialFuncionario[0]?.fechaFin ? '#3b5a1e' : '#6da33c'}`
            }} />
          </Grid>

          <Grid item container xs={10} sx={{ position: "relative" }}>

            <Box sx={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              backgroundColor: funcionario?.historialFuncionario[0]?.fechaFin ? "#3b5a1e" : "#6da33c",
              width: 200,
              position: "absolute",
              right: 0,
              height: 30,
              borderRadius: 10,
              fontWeight: "700",
              letterSpacing: 1
            }}>
              {funcionario?.historialFuncionario[0]?.fechaFin ? "Inactivo" : "Activo"}
            </Box>

            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontSize: "1.40rem", fontWeight: "700", color: "#5d5151" }}>{funcionario.fullName}</Typography>
              <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>{funcionario.institucion}</Typography>
            </Grid>

            <Grid container item xs={12} spacing={2}>

              <Grid container item xs={6} sx={{}}>

                <Grid container item xs={5} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }}>Cargo:</Typography>
                </Grid>

                <Grid container item xs={7} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>{funcionario?.cargo || "N/A"}</Typography>
                </Grid>

              </Grid>

              <Grid container item xs={6} sx={{}}>

                <Grid container item xs={5} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }}>Fecha de ingreso:</Typography>
                </Grid>

                <Grid container item xs={7} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>
                    {funcionario?.historialFuncionario[0]?.fechaInicio || "N/A"}
                  </Typography>
                </Grid>

              </Grid>

            </Grid>


            <Grid container item xs={12} spacing={2} justifyContent={"space-between"}>

              <Grid container item xs={6} sx={{}}>

                <Grid container item xs={5} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }} >Correo electrónico:</Typography>
                </Grid>

                <Grid container item xs={7} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151", width: 50 }} flexWrap={true}>{funcionario?.email || "N/A"}</Typography>
                </Grid>

              </Grid>

              <Grid container item xs={6} sx={{}}>

                <Grid container item xs={5} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }}>Teléfono:</Typography>
                </Grid>

                <Grid container item xs={7} sx={{}}>
                  <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>
                    {funcionario?.telefono?.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-888-9566') || "N/A"} Ext.: {funcionario.extension || "N/A"}
                  </Typography>
                </Grid>

              </Grid>

            </Grid>

          </Grid>

        </Grid>

        {/* <Collapse in={open}>
          <Box sx={{ marginTop: 2, width: "100%" }}>
            <Typography variant="body1"><strong>Cédula:</strong> {funcionario.cedula}</Typography>
            <Typography variant="body1"><strong>Cargo:</strong> {funcionario.cargo}</Typography>
            <Typography variant="body1"><strong>Área:</strong> {funcionario.area}</Typography>
            <Typography variant="body1"><strong>Género:</strong> {funcionario.genero}</Typography>
            <Typography variant="body1"><strong>Email:</strong> {funcionario.email}</Typography>
            <Typography variant="body1"><strong>Teléfono:</strong> {funcionario.telefono}</Typography>
            <Typography variant="body1"><strong>Fecha de Decreto:</strong> {funcionario.fechaDecreto}</Typography>
            <Typography variant="body1"><strong>Funciones:</strong></Typography>
            <Box sx={{ paddingLeft: 2 }}>
              <ul dangerouslySetInnerHTML={{ __html: funcionario.funciones }} />
            </Box>
          </Box>
        </Collapse> */}
      </CardContent>

      <PersonalitiesModalForm openModalEdit={openModalEdit} funcionario={selectedValuesToEdit} onClose={() => { onClose(); selectValuesToEdit({}); setOpenModalEdit(false) }} />


    </Card >
  );
};


const Personalities = () => {
  const [loading, setLoading] = useState(false);
  const [loadingOrg, setLoadingOrg] = useState(false);
  const [personalityName, setPersonalityName] = useState("")
  const [organizationList, setorganizationList] = useState([]);
  const [personalitiesList, setPersonalitiesList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filterName, setFilterName] = useState("");
  const [organizationSelected, setOrganizationSelected] = useState({ _id: 0, nombre: "" });

  const [openOrganizationList, setOpenOrganizationList] = useState(false);
  const axios = useAxios();

  const [openModalEdit, setOpenModalEdit] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getOrganizations = useCallback(async () => {
    try {
      const USERS_API = `/personalities/organizations?page=${1}&limit=30${filterName ? `&nombre=${filterName}` : ''}&role=${"Soporte"}`
      setorganizationList([])
      setLoadingOrg(true);
      const { data } = await axios.get(USERS_API);
      setorganizationList(data?.data?.list);

    } catch (error) {
      console.log(error);
    } finally {
      setLoadingOrg(false);
    }
  }, [axios, setLoadingOrg, filterName]);

  const getPersonalities = useCallback(async () => {
    try {
      const api = `/personalities?page=${page}&limit=10${personalityName ? `&fullName=${personalityName}` : ''}${organizationSelected ? `&institucionId=${organizationSelected._id}` : ''}`
      setPersonalitiesList([])
      setLoading(true);
      const { data } = await axios.get(api);
      setPersonalitiesList(data?.data?.list);
      setTotalPages(data?.data?.total_pages);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, setLoading, page, personalityName, organizationSelected]);

  const onClose = ()=>{
    getPersonalities(); 
    setOpenModalEdit(false)
  }

  useEffect(() => {
    getOrganizations();
  }, [filterName])


  useEffect(() => {
    getPersonalities();
  }, [organizationSelected, personalityName, page])


  return (
    <>
      <PersonalitiesModalForm openModalEdit={openModalEdit} funcionario={{}} onClose={onClose} />

      <Helmet>
        <title>Personalidades | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>

      <Grid sx={{ height: "85vh", position: "relative" }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Personalidades
          </Typography>

          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => setOpenModalEdit(true)}>
            Agregar personalidad
          </Button>
        </Stack>

        <Grid item container alignItems={"center"} spacing={2} p={1} >

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              label="Nombre: "
              value={personalityName}
              onChange={(e) => {
                setPersonalityName(e.target.value)
                setPage(1)
              }}
              variant="outlined"
            />
          </Grid>


          <Grid item xs={12} sm={6}>
            <Autocomplete
              size="small"
              fullWidth
              id="support_assigned"
              open={openOrganizationList}
              onOpen={() => {
                setOpenOrganizationList(true);
              }}
              onClose={() => {
                setOpenOrganizationList(false);
              }}
              isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
              getOptionLabel={(option) =>
                option.nombre
              }
              options={organizationList}
              defaultValue={{ _id: organizationSelected?._id || "", nombre: organizationSelected?.nombre || "" }}
              loading={loading}
              onChange={(_e, value) => {
                if (!value) {
                  setOrganizationSelected(null)
                  setFilterName("")
                  setPersonalityName("")
                }
                setOrganizationSelected(value)
                setPage(1)
              }}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  {...params}
                  label="Institución"
                  onChange={(e) => {
                    setFilterName(e.target.value)
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingOrg ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

          </Grid>

        </Grid>

        {
          personalitiesList?.map((personality) =>
            <FuncionarioCard funcionario={personality} onClose={onClose} />
          )
        }

        {
          loading === true &&
          <Grid sm={12} textAlign={"center"} mt={12}>
            <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />
          </Grid>
        }

        {
          personalitiesList.length > 0 &&
          <Grid sm={12} textAlign={"left"} mb={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePage}
              sx={{ color: "#ffe7d9", marginBottom: 5 }}
            />
          </Grid>
        }

      </Grid >
    </>
  );
}

export default function PersonalitiesPage() {
  return (
    <Personalities />
  )
}